import styles from './authMarketingSideFallback.module.scss';

const LOGIN_SKELETON_BAR_HEIGHTS = ['40%', '50%', '55%', '60%', '65%', '75%', '85%', '95%'];

/** Skeleton matching {@link LoginSideContent} layout. */
export default function LoginMarketingSkeleton() {
    return (
        <>
            <div className={styles.pill}>
                <span className={styles.pillDot} />
                <div className={`${styles.skeletonLine} ${styles.pillText}`} />
            </div>

            <div className={styles.headingSection}>
                <div className={styles.titleBlock}>
                    <div className={`${styles.skeletonLine} ${styles.titleLinePrimary}`} />
                    <div className={`${styles.skeletonLine} ${styles.titleLineHighlight}`} />
                </div>
                <div className={styles.divider} />
                <div className={styles.descriptionBlock}>
                    <div className={`${styles.skeletonLine} ${styles.descriptionLine}`} />
                    <div className={`${styles.skeletonLine} ${styles.descriptionLineShort}`} />
                </div>
            </div>

            <div className={styles.chartSection}>
                <div className={styles.barChart}>
                    {LOGIN_SKELETON_BAR_HEIGHTS.map((height, index) => (
                        <div key={index} className={styles.bar} style={{ height }} />
                    ))}
                </div>
                <div className={styles.statsGrid}>
                    {[0, 1].map((index) => (
                        <div key={index} className={styles.stat}>
                            <div className={`${styles.skeletonLine} ${styles.statLabel}`} />
                            <div className={`${styles.skeletonLine} ${styles.statValue}`} />
                            <div className={`${styles.skeletonLine} ${styles.statTrend}`} />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
